import { AgxSelectChip } from '@urbanx/agx.ui-components2';
import { AssigneeOption } from './taskCollapsibleShared';

interface TaskAssigneeSelectProps {
  id: string;
  value?: string;
  options: AssigneeOption[];
  onAssign: (userId?: string) => void;
}

const TaskAssigneeSelect = ({ id, value, options, onAssign }: TaskAssigneeSelectProps) => {
  const handleSelect = (selectedOptions: AssigneeOption[]) => {
    const selectedValue = selectedOptions.find((option) => option.selected)?.value;
    onAssign(selectedValue === 'Unassigned' ? undefined : selectedValue);
  };

  return (
    <AgxSelectChip
      id={id}
      variant="icon"
      label=""
      onSelect={handleSelect}
      size="medium"
      type="single-select"
      defaultSelection={value}
      options={options}
      searchPlaceHolder="Search"
      align="right"
      hideFooter
    />
  );
};

export default TaskAssigneeSelect;
